import apiService from '../../../apiService'
import Notification from '../../../../../../../../resources/js/notification'
const AGGREGATE_DEFAULT_VALUE = {}
const QUERIES_DEFAULT_VALUE = []

export default {
  namespaced: true,
  state: {
    aggregate: AGGREGATE_DEFAULT_VALUE,
    queries: QUERIES_DEFAULT_VALUE,
    fetching: true
  },
  mutations: {
    setAggregate (state, aggregate) {
      state.aggregate = aggregate || AGGREGATE_DEFAULT_VALUE
    },
    setQueries (state, queries) {
      state.queries = queries || QUERIES_DEFAULT_VALUE
    }
  },
  actions: {
    fetch ({ state, commit }, { idParent, sengine, from, to, type }) {
      state.fetching = true
      commit('setAggregate')
      commit('setQueries')

      apiService.getPositions(idParent, sengine, from, to, type)
        .then(response => {
          commit('setAggregate', response.data.aggregate)
          commit('setQueries', response.data.queries)
          window.vue.$emit('projectPositionsLoaded')

          state.fetching = false
        })
        .catch(() => {
          commit('setAggregate')
          commit('setQueries')
          state.fetching = false

          Notification.notifyError({
            title: 'Ошибка',
            content: 'Не удалось загрузить отчет по позициям.'
          })
        })
    }
  },
  getters: {
    getPeriodDates: state => sengine => {
      if (state.aggregate[sengine]) {
        return Object.keys(state.aggregate[sengine].top5_percent.on_period)
      }

      return []
    },
    getLastPeriodDate: (state, getters) => (sengine) => {
      return getters.getPeriodDates(sengine).slice(-1)[0]
    },
    hasPeriodDates: (state, getters) => (sengine) => {
      return getters.getPeriodDates(sengine).length > 0
    },
    getAggregateParamPeriodValue: (state) => (sengine, param, date) => {
      if (state.aggregate[sengine]) {
        return state.aggregate[sengine][param].on_period[date]
      }

      return null
    },
    getAggregateParamStartValue: (state) => (sengine, param) => {
      if (state.aggregate[sengine]) {
        return state.aggregate[sengine][param].on_start
      }

      return null
    },
    queriesFiltered: state => search => {
      return state.queries.filter((query) => query.txt.includes(search))
    },
    queriesFilteredAndPaginated: (state, getters) => (search, page, perPage) => {
      return getters.queriesFiltered(search).slice((page - 1) * perPage, page * perPage)
    },
    getQuery: state => id => {
      return state.queries.find((query) => query.id === id)
    },
    getQueryPositionValue: (state, getters) => (id, sengine, date) => {
      const query = getters.getQuery(id)
      if (query) {
        return query.positions[sengine][date]
      }

      return null
    }
  }
}
